import { buildStardustHandoffUrl } from 'utils/stardustHandoff';

import type { ProgramCategory, UserProgram } from 'models/programs.types';

/**
 * Stardust hand-off URL for the first program with a Stardust post-onboarding flow configured,
 * optionally restricted to `category`. Whether the patient still needs onboarding is the
 * caller's decision. Returns `null` when there is no such program or its URL is invalid, so
 * callers fall back to the in-portal intake.
 */
export const getStardustPostOnboardingUrl = ({
  accessToken,
  activePrograms = [],
  category
}: {
  accessToken?: string | null;
  activePrograms?: UserProgram[];
  category?: ProgramCategory;
}): string | null => {
  const target = activePrograms.find(
    ({ program }) =>
      (!category || program.category === category) && !!program.stardustPostOnboardingUrl
  );
  if (!target?.program.stardustPostOnboardingUrl) return null;

  return buildStardustHandoffUrl(target.program.stardustPostOnboardingUrl, { accessToken });
};
